import { useEffect, useState } from "react";
import { getHotTopics } from "../utils/api";

let cache = null; // { data, ts }
let inflight = null;
const TTL = 10 * 60 * 1000;

function load() {
  if (cache && Date.now() - cache.ts < TTL) return Promise.resolve(cache.data);
  if (!inflight) {
    inflight = getHotTopics()
      .then((d) => {
        cache = { data: d, ts: Date.now() };
        return d;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export default function useHotTopics() {
  const [data, setData] = useState(cache?.data || null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    load()
      .then((d) => alive && (setData(d), setError(false)))
      .catch(() => alive && setError(true));
    return () => {
      alive = false;
    };
  }, []);

  return {
    items: data?.items || [],
    updatedAt: data?.updated_at || null,
    loading: !data && !error,
    error,
  };
}